/* Product card specifc */

function updateProductPositions() {
	const productCards = document.getElementsByClassName('product-list-item');
	for (let i = 0; i < productCards.length; i++) {
		if (!productCards[i].getAttribute('data-position')) {
			productCards[i].setAttribute('data-position', i + 1);
		}
	}
}

/**
 * Creates an object to use in datalayer from product-list-item
 *
 * @param {object}  productItem - product-list-item dom node (not jquery)
 *
 * @return {object} datalayer params - Product info for datalayer
 */
function getProductDataLayerData (productItem) {
	let position = productItem.getAttribute('data-position');
	if (!position) {
		updateProductPositions();
		position = productItem.getAttribute('data-position');
	}

	const link = productItem.querySelector('a.product-link');
	const url = link.getAttribute('href');

	let sapId = '';
	let color = '';

	const identifierParts = String(productItem.dataset.identifier).split('_');

	if (identifierParts.length === 2) {
		[sapId, color] = identifierParts;
		color = color.toUpperCase();
	}

	if (!(sapId && color)) {

		try {
			const urlObject = link?.href ? new URL(link.href) : null;

			if (urlObject) {

				const urlColor = String(urlObject.searchParams.get('color') || '').toUpperCase();
				let urlSapId = String(urlObject.pathname.split('-').pop() || '');
				if (urlSapId.endsWith('/')) {
					[urlSapId] = urlSapId.split('/');
				}

				if (urlSapId && urlColor) {
					sapId = urlSapId;
					color = urlColor;
				}
			}

		} catch (error) {
			// Url parsing error
		}

	}

	const list = productItem.closest('.product-carousel') ? 'Karuselli' : productItem.closest('#search-page') ? 'Sivustohaku' : 'Tuotelistaus';

	const productName = String(productItem.querySelector('.product-name .name')?.textContent || '').trim();
	const productBrand = String(productItem.querySelector('.product-name .brand')?.textContent || '').trim();
	const productData = productItem.dataset;

	const priceContainer = productItem.querySelector('.product-price');
	const priceSelector = priceContainer.classList.contains('sale') ? '.discount' : '.normal';
	const price = parseFloat(priceContainer?.querySelector(priceSelector)?.textContent || 0);

	return {
		id: sapId,
		price,
		list,
		link: url,
		name: productName,
		brand: productBrand,
		category: productData.categoryPath,
		sports: productData.sports,
		targetgroup: productData.targetgroup,
		breadcrumb: productData.fullCategoryPath,
		position: parseInt(position),
		dimension16: sapId + '_' + color
	};
}

export { getProductDataLayerData };
